export enum NotificationStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export interface NotificationLog {
  id: string;
  templateId: string;
  templateName: string;
  recipient: string;
  status: NotificationStatus;
  scheduledTime: string; // Changed to match backend DTO
  errorMessage?: string;
  channel: "EMAIL" | "SMS"; // Explicitly define channel types
}

export type SortField =
  | "templateName"
  | "recipient"
  | "status"
  | "scheduledTime" // Changed to match backend sorting
  | "channel";
export type SortDirection = "asc" | "desc";

// Pagination and filtering types
export interface NotificationLogFilters {
  page: number;
  size: number;
  sortBy?: SortField;
  sortDirection?: SortDirection;
  statuses?: string[];
  notificationTypes?: string[];
  recipientTypes?: string[];
  recipientSearch?: string;
  templateNameSearch?: string;
  scheduledFromDate?: string;
  scheduledToDate?: string;
  subjectSearch?: string;
}

export interface NotificationLogPage {
  content: NotificationLog[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}
